import React from 'react';
import {
	FaPaintBrush,
	FaPlug,
	FaRunning,
	FaDirections,
	FaShapes,
	FaServer
} from 'react-icons/fa';

import './style.scss';


const Midsection = () => (
	<div>
		<section className="section">
			<div className="container">
				<div className="columns is-multiline">
					<div className="column is-one-third">
						<article className="media">
							<figure className="media-left">
								<span className="icon is-medium">
									<FaPaintBrush size="fa-2x" color="#d22780" />
								</span>
							</figure>
							<div className="media-content">
								<div className="content">
									<h1 className="title is-size-4">Compose</h1>
									<p className="subtitle is-size-5">
										Proc.Works is a declarative API framework for composing buisness objects and workflows using JSON schemas.
									</p>
								</div>
							</div>
						</article>
					</div>
					<div className="column is-one-third">
						<article className="media">
							<figure className="media-left">
								<span className="icon is-medium">
									<FaPlug size="fa-2x" className="has-text-danger" />
								</span>
							</figure>
							<div className="media-content">
								<div className="content">
									<h1 className="title is-size-4">Connect</h1>
									<p className="subtitle is-size-5">
										Link objects and actions together into workflows that solve your most challenging business operations problems.
									</p>
								</div>
							</div>
						</article>
					</div>
					<div className="column is-one-third">
						<article className="media">
							<figure className="media-left">
								<span className="icon is-medium">
									<FaRunning size="fa-2x" color="#5e227f" />
								</span>
							</figure>
							<div className="media-content">
								<div className="content">
									<h1 className="title is-size-4">Act</h1>
									<p className="subtitle is-size-5">
										Build custom GUIs or integrate into existing applications to enable your users to make better decisions and take swifter action.
									</p>
								</div>
							</div>
						</article>
					</div>
					<div className="column is-one-third">
						<article className="media">
							<figure className="media-left">
								<span className="icon is-medium">
									<FaDirections size="fa-2x" color="blue" />
								</span>
							</figure>
							<div className="media-content">
								<div className="content">
									<h1 className="title is-size-4">Event Driven</h1>
									<p className="subtitle is-size-5">
										You shouldn't have to pull data when you need it.  Not only is Proc.Works API driven it also provides a common method for Publishing and Subscribing to event streams as data changes.
									</p>
								</div>
							</div>
						</article>
					</div>

					<div className="column is-one-third">
						<article className="media">
							<figure className="media-left">
								<span className="icon is-medium">
									<FaShapes size="fa-2x" className="has-text-primary" />
								</span>
							</figure>
							<div className="media-content">
								<div className="content">
									<h1 className="title is-size-4">Free Your Data</h1>
									<p className="subtitle is-size-5">
										Don't let your data be walled off and slowed down through a cumbersome and expensive service.  Access your data whenever you want, however you want, at scale.
									</p>
								</div>
							</div>
						</article>
					</div>
					<div className="column is-one-third">
						<article className="media">
							<figure className="media-left">
								<span className="icon is-medium">
									<FaServer size="fa-2x" className="has-text-danger" />
								</span>
							</figure>
							<div className="media-content">
								<div className="content">
									<h1 className="title is-size-4">API First</h1>
									<p className="subtitle is-size-5">
										Proc.Works is not prescriptive on how you render or deliver your business objects, integrate your workflows, or allow your users to interact with your data.
									</p>
								</div>
							</div>
						</article>
					</div>
				</div>
			</div>
		</section>
	</div>
);

export default Midsection;
